export * from './project-host.js'
export * from './project-activity.js'
export * from './project-tool-scope.js'
export const name = '@tnega/project-host'
